module.exports = __webpack_public_path__ + "img/Frame 1089two.072127ce.png";